import { Component, Input } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { MbConstants } from '../../../../shared/mb-constants'

@Component({
  selector: 'mb-checkout-contact-base-form-partial',
  templateUrl: './mb-checkout-contact-base-form-partial.component.html'
})
export class MbCheckoutContactBaseFormPartialComponent {

  constants = MbConstants
  @Input() formGroup: UntypedFormGroup | undefined
  @Input() isEmailDisabled: boolean = true
  @Input() firstNameLabelKey: string = 'contact.firstName'
  @Input() lastNameLabelKey: string = 'contact.lastName'
  @Input() emailLabelKey: string = 'contact.email'
  @Input() phoneNumberLabelKey: string = 'contact.phoneNumber'
  @Input() isFormDisabled: boolean | undefined
}
